import { ChangeEventHandler, FC, useState } from 'react';
import SectionHead from '../../SectionHead';
import CompanyInfoForm from '../CompanyInfoForm';
import { useFormContext } from 'react-hook-form';
import { CompanyInfo, ContractFormData } from '../../../../../types/contracts';
import CheckBox from '../../../../../components/common/CheckBox';
import styles from './styles.module.css';
import { generateCompanyInfo } from '../../../generateFormData';

const setValueOpt = {
  shouldDirty: true,
  shouldTouch: true,
};
const ContractorCompany: FC = () => {
  const { getValues, setValue } = useFormContext<ContractFormData>();
  const value = getValues('contractorCompanyInfo');
  const [visibleForm, setVisibleForm] = useState(!!value);
  const [companyInfo, setCompanyInfo] = useState<CompanyInfo | null>(
    value || generateCompanyInfo()
  );
  const onCheck: ChangeEventHandler<HTMLInputElement> = (e) => {
    const checked = e.target.checked;
    setVisibleForm(checked);
    if (!checked) setCompanyInfo(getValues('contractorCompanyInfo'));
    setValue(
      'contractorCompanyInfo',
      checked ? companyInfo : null,
      setValueOpt
    );
  };
  return (
    <>
      <SectionHead>
        <div className={styles.label}>
          委託先
          <div className={styles.checkbox}>
            <CheckBox label="有り" checked={visibleForm} onChange={onCheck} />
          </div>
        </div>
      </SectionHead>
      {visibleForm && value && (
        <CompanyInfoForm namePrefix={'contractorCompanyInfo'} />
      )}
    </>
  );
};
export default ContractorCompany;
